export const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE'

export const SET_SELECTED_PRODUCTS = 'SET_SELECTED_PRODUCTS'

export const SET_SELECTED_STATUS = 'SET_SELECTED_STATUS'

export const SET_SEARCH = 'SET_SEARCH'

export const GET_AVAILABLE_LANGUAGES = 'GET_AVAILABLE_LANGUAGES'
export const GET_AVAILABLE_LANGUAGES_PENDING = 'GET_AVAILABLE_LANGUAGES_PENDING'
export const GET_AVAILABLE_LANGUAGES_FULFILLED = 'GET_AVAILABLE_LANGUAGES_FULFILLED'
export const GET_AVAILABLE_LANGUAGES_ERROR = 'GET_AVAILABLE_LANGUAGES_ERROR'

export const GET_AVAILABLE_PRODUCTS = 'GET_AVAILABLE_PRODUCTS'
export const GET_AVAILABLE_PRODUCTS_PENDING = 'GET_AVAILABLE_PRODUCTS_PENDING'
export const GET_AVAILABLE_PRODUCTS_FULFILLED = 'GET_AVAILABLE_PRODUCTS_FULFILLED'
export const GET_AVAILABLE_PRODUCTS_ERROR = 'GET_AVAILABLE_PRODUCTS_ERROR'

export const GET_TRANSLATIONS_FOR_PRODUCT = 'GET_TRANSLATIONS_FOR_PRODUCT'
export const GET_TRANSLATIONS_FOR_PRODUCT_PENDING = 'GET_TRANSLATIONS_FOR_PRODUCT_PENDING'
export const GET_TRANSLATIONS_FOR_PRODUCT_FULFILLED = 'GET_TRANSLATIONS_FOR_PRODUCT_FULFILLED'
export const GET_TRANSLATIONS_FOR_PRODUCT_ERROR = 'GET_TRANSLATIONS_FOR_PRODUCT_ERROR'

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const UPDATE_PRODUCT_PENDING = 'UPDATE_PRODUCT_PENDING'
export const UPDATE_PRODUCT_FULFILLED = 'UPDATE_PRODUCT_FULFILLED'
export const UPDATE_PRODUCT_ERROR = 'UPDATE_PRODUCT_ERROR'

export const ADD_TRANSLATION = 'ADD_TRANSLATION'
export const ADD_TRANSLATION_PENDING = 'ADD_TRANSLATION_PENDING'
export const ADD_TRANSLATION_FULFILLED = 'ADD_TRANSLATION_FULFILLED'
export const ADD_TRANSLATION_ERROR = 'ADD_TRANSLATION_ERROR'

export const RESET_ADD_TRANSLATION = 'RESET_ADD_TRANSLATION'
